import { WorkspaceConfirmDeleteRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/confirm_delete')({
  component: WorkspaceConfirmDeleteRoute,
});
